import React from 'react'

import poweredBy from '@/assets/images/powered_by_vertical.png'
import wordmark from '@/assets/images/wordmark.svg'
import { FOOTER_HEIGHT } from '@/utils/constants'

/**
 * Footer
 *
 * A component that provides a consistent footer for the application.
 *
 * @returns {JSX.Element} - The rendered Footer component.
 */
const Footer = () => (
  <div
    className="bg-midnight relative flex w-full place-content-center items-center"
    style={{ height: `${FOOTER_HEIGHT}px` }}
  >
    <div className="flex w-full flex-row items-center justify-center gap-8 md:gap-12">
      <img aria-hidden="true" className="z-10 h-6 sm:h-7" src={wordmark} alt="Logo" />
      <img
        aria-hidden="true"
        className="z-10 h-8 sm:h-9"
        src={poweredBy}
        alt="Powered By Warranty Processing"
      />
    </div>
  </div>
)

export default Footer
